import { GD } from "src/GD";
import { AppRole, hasPermission, hasRole, Permission, ProjectRole } from "src/permissions";

export const useProjectRoles = (): ProjectRole[] => {
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);
	return project && user ? (user.projects.find(val => val.id === project.id)?.roles ?? []) : [];
};

export const useHasRole = (role: AppRole): boolean => hasRole(useProjectRoles(), role);

export const useHasPermission = (permission: Permission): boolean => hasPermission(useProjectRoles(), permission);

export const useIsManagerRole = (clientUserId?: number) => {
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);

	if (!project || !user) return false;

	const userProject = user.projects.find(val => val.id === project.id);
	if (!userProject) return false;

	return (
		hasRole(userProject.roles, "admin") ||
		hasRole(userProject.roles, "manager") ||
		(hasRole(userProject.roles, "merchant") && user.id === clientUserId)
	);
};

export const useIsMerchantRole = () => {
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);

	if (!project || !user) return false;

	const userProject = user.projects.find(val => val.id === project.id);
	if (!userProject) return false;

	return hasRole(userProject.roles, "merchant");
};
